import { render } from "./TemplateSelector.vue?vue&type=template&id=2de9ac93"
import script from "./TemplateSelector.vue?vue&type=script&lang=js"
export * from "./TemplateSelector.vue?vue&type=script&lang=js"
script.render = render

export default script